/**
 * Cliente Firebase del frontend (env REACT_APP_FIREBASE_*).
 */
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"; // Importamos el servicio de Auth
import { getStorage } from "firebase/storage"; // Importar getStorage
import { getFirestore } from "firebase/firestore"; // 1. Importar Firestore

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Inicializamos la app de Firebase
const app = initializeApp(firebaseConfig);

// 2. Inicializamos los servicios y los exportamos
export const db = getFirestore(app);
// Exportamos 'auth' para que los demás archivos puedan usarlo
export const auth = getAuth(app);
export const storage = getStorage(app);
